import { RgCreate as f, DefaultFloor as W, RG_TYPE as A } from "@project-rouge/rg-core";
import { differencePolygons as E } from "../../geometry-utils/clipper-utils/index3.js";
import { getPolygonArea as L } from "../../geometry-utils/core/index14.js";
import { getPolySizeAndPos as z } from "../../utils/index15.js";
import { getBuildingBoundary as p } from "../boundary/index5.js";
import { offsetPolygon as R } from "../../geometry-utils/clipper-utils/index5.js";
const b = 1e-4;
function Y({ building: t, podiumStart: i, podiumCount: u, podiumHeight: y, areaThreshold: v = 0.25 }) {
  const c = [], s = t.data.levels.sort((o, l) => o.floorWorldBottom - l.floorWorldBottom), P = s.filter((o) => o.isPodium), B = s[i + u];
  for (const o of P) {
    const l = p(t, [o.levelIndex, B.levelIndex]), g = R(p(t, [o.levelIndex]), b), h = E(l, [g]);
    for (const x of h) {
      const n = x.map((e) => [e[0], o.floorWorldBottom, e[2]]);
      if (L(n) <= v)
        continue;
      const d = [0.5, 0, 0.5], { size: I, pos: r } = z(n, d, o.floorWorldBottom, y), m = n.map((e) => [e[0] - r[0], e[1] - r[1], e[2] - r[2]]), S = f({
        ...W,
        data: {
          polygon: m
        }
      }, []), a = f({
        type: A.EmptySpace,
        children: [
          S
        ],
        name: "Podium empty space",
        size: I,
        pos: r,
        color: "#ace6c0",
        anchor: d,
        data: {
          level: o.levelIndex,
          levelId: o.uuid,
          polygon: m
        }
      }, []);
      t.children.push(a), c.push(a);
    }
  }
  return c;
}
export {
  Y as createPodiumEmptySpaces
};
//# sourceMappingURL=index.js.map
